import React from 'react'
import { withStyles, Theme, createStyles } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'

interface StyledTabProps {
  label: string
}

const OutfitTab = withStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(0, 2),
      minWidth: 0,
      borderRadius: theme.shape.borderRadius * 3,
      minHeight: 32,
      textTransform: 'none',
      color: theme.palette.common.black,
      backgroundColor: theme.extraColors.greyLight,
      opacity: 1,
      '&+.MuiTab-root': {
        marginLeft: 10,
      },
      '& .MuiButtonBase-root': {
        height: 32,
      },
      '&:hover': {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
      },
      '&$selected': {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
      },
      '& > span': {
        flexDirection: 'row',
        '& > :first-child': {
          marginBottom: '0 !important',
        },
      },
    },
    selected: {},
  })
)(
  (props: StyledTabProps) => (
    <Tab {...props} />
  ) /* eslint-disable-line react/jsx-props-no-spreading */
)

export default OutfitTab
